<template>
  <div>
    <Breadcrumbs main="Folyo" title="Folyo" :links="breadLinks" />

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <b-card
            header-tag="div"
            header-bg-variant="primary"
            class="card-absolute"
          >
            <h5 slot="header">Folyo</h5>
            <b-card-body class="p-1">
              <AracFolyo
                :arac="arac"
                v-if="isFolyoLoad"
                :noEdit="true"
              ></AracFolyo>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AracFolyo from "@/components/c_arac_folyo";

export default {
  data() {
    return {
      pageTitle: "Folyo",

      breadLinks: [],

      arac: {},

      isFolyoLoad: false,
    };
  },
  mounted() {
    this.onDetay();
  },
  components: {
    AracFolyo,
  },
  methods: {
    onDetay() {
      let vm = this;

      this.$connection.get("/araclar/profil", function (response) {
        if (response.Success) {
          vm.arac = response.Data;

          vm.isFolyoLoad = true;
        } else {
          vm.$alert.messageWithTitle("Araç", response.Message, "error");
        }
      });
    }
  },
};
</script>
